import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Div from "../../../widget/common/ui/Div";
import SettingsMenu from "./widget/SettingsMenu";
import SettingsLogout from "./widget/SettingsLogout";
import SettingsProfile from "./widget/SettingsProfile";
import { SpacingHeight } from "../../../widget/common/ui/Spacing";
import { ProfileDetails } from "../../../model/settings/SettingsPersonalInfoModel";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import { SettingsPersonalProfileContextImport } from "../../../provider/settings/manage_personal_profile/SettingsPersonalProfileContextProvider";
import { Col } from "react-bootstrap";

const SettingsContent = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const { getProfileInfo, profileDetail } =
    SettingsPersonalProfileContextImport();

  const [profileInfo, setProfileInfo] = useState<ProfileDetails | null>(null);

  useEffect(() => {
    getProfileInfo();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setProfileInfo(profileDetail);
  }, [profileDetail]);

  return (
    <div
      className={`${profileInfo != null ? "d-grid" : ""} h-100`}
      style={{ gridTemplateRows: `1fr 150px` }}
    >
      {profileInfo == null ? (
        <Center className="h-100">{Loader.normal()}</Center>
      ) : (
        <>
          <Div className="pb-3">
            <Col xs={12} lg={10} className="mx-auto">
              <SettingsProfile type={type} profileInfo={profileInfo} />
              <SpacingHeight value={type === 1 ? 15 : 30} />
              <SettingsMenu type={type} />
            </Col>
          </Div>
          <SettingsLogout />
        </>
      )}
    </div>
  );
};
export default SettingsContent;
